import { customElement, WebComponent } from '@/lib/components'

import styles from './DialogHeader.styles.css'

@customElement('solid-ui-dialog-header')
export default class DialogHeader extends WebComponent {
  static styles = styles
}
